import { render, staticRenderFns } from "./BaseResult.vue?vue&type=template&id=73a0d7d6&scoped=true&"
import script from "./BaseResult.vue?vue&type=script&lang=js&"
export * from "./BaseResult.vue?vue&type=script&lang=js&"
import style0 from "./BaseResult.vue?vue&type=style&index=0&id=73a0d7d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a0d7d6",
  null
  
)

export default component.exports